/** @format */

interface Options {
  amount?: number | null;
  firstPaymentMonthlyAmount?: number | null;
}

/**
 * Цена месяца, которую видит пользователь: цена первого счёта со всеми скидками,
 * а если биллинг её не прислал — цена по прайсу.
 * Поле firstPaymentMonthlyAmount nullable: его нет в ответе, когда тариф не пришёл
 * в персональных ценах или у плана нет длинных сроков.
 */
const getActualMonthlyAmount = ({amount, firstPaymentMonthlyAmount}: Options): number =>
  firstPaymentMonthlyAmount ?? amount ?? 0;

export {getActualMonthlyAmount};
